import { DerogationButton } from './DerogationButton';

export function CreateConfirmDerogationButton({
  overridenBranchId,
}: {
  overridenBranchId?: string;
}) {
  return <DerogationButton action="CONFIRM" overridenBranchId={overridenBranchId} />;
}
